import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { IRootState } from "../../../../reducer/CombineReducer";
import { FetchOutputConfigList } from "../../OutputConfig/OutputConfigLandingPage/OutputConfigList/Script";
import { useUser } from "../../../../AuthContext";
import { OutputConfigPickerView } from "./OutputConfigPicker.view";

interface Props {
  /**
   * Action on toggle
   */
  onToggle: () => void;
  /**
   * Action on pick
   */
  onPick: (id: string, name: string) => void;
}

export const OutputConfigPicker: React.FC<Props> = (props: Props) => {
  const { onToggle, onPick } = props;
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const [
    extractState,
    scheduling
  ] = useSelector((state: IRootState) => [
    state.extractState,
    state.scheduling
  ], shallowEqual);
  const { selectedExtract } = extractState;
  const extractGuid = selectedExtract?.extractGuid as string;
  const { pickerConfigList } = scheduling;
  const { user } = useUser();
  const env = process.env.APP_TARGET_ENV as Environments;

  useEffect(() => {
    FetchOutputConfigList(dispatch, translate, extractGuid, env, user?.token, true);
  }, []);

  return (
    <>
      {
        pickerConfigList.length > 0 &&
        <OutputConfigPickerView
          onClose={onToggle}
          title={"Scheduling.Heading.OutputConfigPicker"}
          configList={pickerConfigList}
          onPick={onPick}
        />
      }
    </>
  );
};
